// 要素までスクロールする関数
const scrollToElement = (targetId, offset) => {
  const targetElement = document.querySelector(targetId);
  if (targetElement) {
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: targetPosition - offset,
      behavior: 'smooth'
    });
  }
};

// ページ内リンクの処理を設定する関数
export const setupScrollLinks = (offset) => {
  ///console.log(window.location.hash, offset);
    // ページ読み込み時にハッシュが存在する場合にスクロール
    if (window.location.hash) {
      setTimeout(() => {
        scrollToElement(window.location.hash, offset);
      }, 500);
    }



  setTimeout(() => {
  // ハッシュを含むすべてのリンクを対象にする
  document.querySelectorAll('a[href*="#"]').forEach(anchor => {
    //console.log(`anchor`, anchor);

    anchor.addEventListener('click', function (e) {
      //console.log(`click`);
      const href = this.getAttribute('href');
      //console.log(`href`, href);
      // 現在のページURLを取得
      const currentPageURL = window.location.pathname;
      //console.log(`currentPageURL`, currentPageURL);


      // ハッシュがページ内リンクかどうかを判別
      if (href.startsWith("#") || href.startsWith(currentPageURL + "#")) {
        // ページ内リンクの場合
        e.preventDefault();
        const targetId = href.includes("#") ? href.substring(href.indexOf("#")) : href;
        //console.log(targetId);

        scrollToElement(targetId, offset);
      } else {
        // 別ページへのリンクの場合は通常の遷移
        window.location.href = href;
      }
    });
  });
  }, 500);

};